<template>
  <div class="lv-upload-img-btn">
    <LvText v-if="title" h6 bold>{{ $t(title) }}</LvText>
    <div class="lv-upload-img-btn__btn" @click="$_onClickUpload()">
      <div v-if="isTextBtn" class="lv-upload-img-btn__text" :class="{ big }">
        <i :class="[`${leadingIcon}`]" class="lv-upload-img-btn__icon" />
        <LvText h6 blue :class="{ 'ml-4': !big }">{{ $t(uploadText) }}</LvText>
      </div>
      <div v-else>
        <WsButton001 normalWidth @click="$_onClickUpload()">
          {{ $t('更換照片') }}
        </WsButton001>
      </div>
    </div>
    <LvText class="mt-8" remark lightGray>{{ $t(_remindText) }}</LvText>
    <LvPopupChooseFile
      acceptFileType="image"
      :oneFile="oneFile"
      :uploadModule="uploadModule"
      :popUpActive="isActive.upload"
      :selectedFileList="selectedFileList"
      @input="$emit('input', $event)"
      @close="$_onClosePopup('upload')"
    />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    isTextBtn: {
      type: Boolean,
      default: true,
    },
    uploadText: {
      type: String,
      default: '圖片',
    },
    uploadModule: {
      type: String,
    },
    oneFile: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: 'icon-photo',
    },
    big: {
      type: Boolean,
      default: false,
    },
    remindText: {
      type: String,
    },
    selectedFileList: {
      type: Array,
    },
  },
  data() {
    return {
      isActive: {
        upload: false,
      },
    };
  },
  computed: {
    _remindText() {
      return this.remindText ? this.$t(this.remindText) : `${this.$t('檔案大小限制')} ≤ 30 MB`;
    },
  },
  methods: {
    $_onClickUpload() {
      this.$_onOpenPopup('upload');
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      if (!this.isActive[type]) return;
      this.isActive[type] = false;
    },
  },
};
</script>
